import BaseListagem from "components/BaseListagem";
import ModalDocumentoVisualizar from "components/modal/documentos/ModalDocumentoVisualizar";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Documento from "model/documentos/Documento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DocumentoService from "service/documentos/DocumentoService";
import { IdMatchModeOptions, ListMatchModeOptions, TextMatchModeOptions, dropdownFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";

const documentoService = new DocumentoService();

export default function DocumentoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Documentos');

    const [documentoVisualizar, setDocumentoVisualizar] = useState<{ visible: boolean, documentoVersao: any, url: string }>({ visible: false, documentoVersao: null, url: "" });

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [categorias, setCategorias] = useState<CategoriaDocumento[]>([]);
    const [pastas, setPastas] = useState<DocumentoPasta[]>([]);

    useEffect(() => {
        documentoService.categorias().then((response) => {
            setCategorias(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
        })
        documentoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
        })
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        categoria: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioCriacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: [],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    return (
        <>
            {documentoVisualizar.visible ? <ModalDocumentoVisualizar
                url={documentoVisualizar.url}
                visible={documentoVisualizar.visible}
                onHide={() => setDocumentoVisualizar({ visible: false, documentoVersao: null, url: "" })}
                documentoVersao={documentoVisualizar.documentoVersao}
            /> : null}
            <BaseListagem
                ordenacao="codigoInterno,ASC"
                service={documentoService} urlService="/documento" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="documento" >
                <Column field="codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                    sortable />

                <Column field="nome" header="Titulo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                    sortable />

                <Column field="tipoGestao" header="Tipo" body={(rowData: Documento) => rowData.tipoGestao === "GED" ? "GED" : "Controlado"} sortable />

                <Column field="categoria.nome" header="Categoria" filter filterField="categoria" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, categorias)}
                    sortable />

                <Column field="usuarioCriacao.nome" header="Usuario Criador" filter filterField="usuarioCriacao" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, usuarios)}
                    sortable />
                <Column field="pastaMae.nome" header="Pasta Mãe" body={(rowData) => rowData.pastaMae?.nome || "(Raiz)"} sortable />
                <Column field="status" header="Status" body={(rowData) => {
                    return <span style={{ borderRadius: 20, padding: 5, paddingLeft: 10, paddingRight: 10, background: documentoService.getStatusColor(rowData.status) }}>{documentoService.getStatus(rowData.status)}</span>
                }}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, documentoService.getListStatusFilter())}
                    sortable />
                <Column body={(rowData : Documento) => {
                    if (rowData.status !== "PUBLICADO") {
                        return <></>
                    }
                    return <Button icon="pi pi-eye" 
                    tooltipOptions={{showOnDisabled: true}}
                    tooltip={rowData.acoesUsuarioLogado.findIndex((acao) => acao.sigla == "VISUALIZAR") >= 0 ? undefined : "Sem permissão para visualizar"}
                    disabled={rowData.acoesUsuarioLogado.findIndex((acao) => acao.sigla == "VISUALIZAR") < 0}
                    onClick={() => {
                        console.log(rowData.versaoVigente)
                        setDocumentoVisualizar({ visible: true, documentoVersao: rowData.versaoVigente, url: rowData.versaoVigente?.arquivo?.url || "" })
                    }} />

                }} />
            </BaseListagem>
        </>
    )
}
